import React, { useState } from 'react'

import { navigate } from 'gatsby'
import * as AddPlanForm from 'components/AddPlanForm'
import * as Building from 'modules/building/components/Reference'
import * as Links from 'components/Links'

import * as Header from 'components/Header'
import * as Footer from 'components/Footer'

import * as Layout from 'layouts/TopPageLayout'
import * as styles from './styles.module.scss'

const Title = () => (
  <div className={styles.TitleContainer}>
    <h1>
      <Building.Properties.NameEn className={styles.TitleText} />
      <small>
        <Building.Properties.NameJa className={styles.TitleSmallText} />
      </small>
    </h1>
  </div>
)

/**
 */
const Page = () => (
  <>
    <Header.Content />
    <AddPlanForm.Container
      onSuccess={() => {
        navigate('/vr')
      }}
    >
      <Layout.Container styles={styles}>
        <Layout.Contents>
          <div className={styles.ContentsWrap}>
            {/* <Title /> */}
            <div className={styles.Content}>
              <AddPlanForm.FormFields />

              <AddPlanForm.Submit className={styles.Submit}>
                お部屋を確認する
              </AddPlanForm.Submit>
            </div>
          </div>
        </Layout.Contents>
      </Layout.Container>
    </AddPlanForm.Container>
    <Footer.Content />
  </>
)

export default Page
